import React,{ useEffect, useState} from "react";
import ReactECharts from 'echarts-for-react';

export default function Lineargauge (props) {
    const [gaugeoptions,setGaugeoptions] = useState({})

    var pathSymbols = {
        marker: 'path://m199.565757,136.944121l21.902885,0l0,34.282792l-10.95145,8.570707l-10.951448,-8.570707l0.000012,-34.282792z'
    }

    var options = { 
        yAxis: {
            show: false,
            boundaryGap: false,
            data: [
              'A'
            ]
        },
        xAxis: {
        type: 'value',
        boundaryGap: true,
        max: 100,
        splitLine: {
            show: true
        },
        axisLabel: {
            formatter: '{value} %'
        }
        },
        series: [{
            type: 'scatter',
            symbol: pathSymbols.marker,
            silent: false,
            itemStyle: {
            normal: {
                color: 'rgba(0,0,0,0.3)',
                borderColor: '#000',
                borderWidth: 1
            }
            },
            symbolSize: [15, 30],
            symbolOffset: ['0%', '0%'],
            z: 20,
            data: [55],
            label: {
            emphasis: {
                show: true,
                formatter: function(param) {
                return param.data + ' %';
                },
                position: 'top'
            }
            },
        },
        {
            type: 'bar',
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
            normal: {
                color: 'rgb(79,173,96)'
            }
            },
            stack: 'total',
            data: [20]
        },
        {
            type: 'bar',
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
            normal: {
                color: 'rgb(157,185,101)'
            }
            },
            stack: 'total',
            data: [20]
        },
        {
            type: 'bar',
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
            normal: {
                color: 'rgb(255,253,91)'
            }
            },
            stack: 'total',
            data: [20]
        },
        {
            type: 'bar',
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
            normal: {
                color: 'rgb(241,147,80)'
            }
            },
            stack: 'total',
            data: [20]
        },
        {
            type: 'bar',
            silent: true,
            animation: false,
            barWidth: 20,
            itemStyle: {
            normal: {
                color: 'rgb(200,82,76)'
            }
            },
            stack: 'total',
            data: [20]
        }
        ]
    }

    useEffect(() => {
        setGaugeoptions(options)
    },[])

    return(
        <div style={{height: '100%', width: '100%',  overflow: 'auto'}}>
            <ReactECharts option={gaugeoptions} style={{ height: '150px', width: '100%', marginTop:"0px" }}/>
        </div>
    )
}



